module.exports = __webpack_public_path__ + "img/DW-icon.00ba449e.png";